import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

interface CategorySidebarProps {
  activeId: string;
}

export default function CategorySidebar({ activeId }: CategorySidebarProps) {
  return (
    <aside className="w-full lg:w-56 shrink-0">
      <div className="lg:sticky lg:top-20">
        <h2 className="text-sm font-bold text-foreground-900 mb-3 px-1">视频分类</h2>
        <nav className="flex lg:flex-col gap-1 overflow-x-auto xg-scroll-hide pb-1 lg:pb-0">
          {categories.map((cat) => {
            const active = cat.id === activeId;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`flex items-center gap-2.5 px-3 py-2.5 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                <i className={`${cat.icon} text-lg`}></i>
                {cat.name}
              </Link>
            );
          })}
        </nav>
      </div>
    </aside>
  );
}